import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import useGetSettingFinancialStatement from '../../../financial/common/useGetSettingFinancialStatement'
import {
  changeSelectedYear,
  selectIsLoadingYear,
  selectYear,
} from './store/slice'
import { getYearReports } from './store/thunk'

export const ValidateYear = ({ children }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const settingFS = useGetSettingFinancialStatement()

  const isLoading = useSelector(selectIsLoadingYear)
  const year = useSelector(selectYear)

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    if (!settingFS.years) {
      dispatch(getYearReports({ OrganizationId: organizationId }))
    } else {
      dispatch(
        changeSelectedYear({
          value: [...settingFS.years].pop(),
          label: [...settingFS.years].pop(),
        }),
      )
    }
  }, [])

  if (isLoading) {
    return <Loading />
  }

  if (!year) {
    return (
      <div className="p1">
        <Notification />
      </div>
    )
  }

  return children
}
